<template>
	<v-card class="mb-3">
		<v-list-item>
			<v-list-item-content>
				<v-row no-gutters>
					<v-col cols="4">
						<v-skeleton-loader v-if="!avatar" type="avatar" :loading="true" width="60" height="60"> </v-skeleton-loader>

						<v-list-item-avatar v-else-if="avatar && avatar != 'no-avatar'" width="60" height="60">
							<v-img :src="avatar"></v-img>
						</v-list-item-avatar>

						<v-list-item-avatar v-else width="60" height="60">
							<v-img :src="no_avatar"></v-img>
						</v-list-item-avatar>
					</v-col>
					<v-col cols="8">
						<v-list-item-title class="secondary--text lighten-1 font-weight-bold">{{ booking.professional.name }}</v-list-item-title>
						<v-list-item-subtitle class="lighten-1 font-weight-bold">{{ booking.professional.profession }}</v-list-item-subtitle>
						<v-tooltip bottom>
							<template #activator="{ on, attrs }">
								<v-list-item-title v-if="showTimes" class="subtitle-2 font-weight-bold" v-bind="attrs" v-on="on"
									>{{ start_time }} - {{ end_time }}</v-list-item-title
								>
								<v-list-item-title v-else-if="!showTimes" class="subtitle-2 font-weight-bold" v-bind="attrs" v-on="on">Times differ per day</v-list-item-title>
							</template>
							<span>
								<v-list-item-group>
									<v-list-item-subtitle v-for="date in booking.booking_dates" :key="date" class="subtitle-2 font-weight-bold">{{ date }}</v-list-item-subtitle>
								</v-list-item-group>
							</span>
						</v-tooltip>
						<v-tooltip v-if="booking.status == 'cancelled'" bottom>
							<template #activator="{ on, attrs }">
								<v-list-item-subtitle :class="['red--text', 'lighten-1', 'font-weight-bold']"
									>{{ booking.status }}
									<v-icon color="primary" dark v-bind="attrs" small v-on="on"> help </v-icon>
								</v-list-item-subtitle>
							</template>
							<span
								><v-row
									><v-col
										>This booking was cancelled by {{ booking.cancelledBy == 'professional' ? 'the locum' : 'you' }} on
										{{ dateFormattedMomentjs(booking.updatedAt) }}</v-col
									></v-row
								></span
							>
						</v-tooltip>
						<v-list-item-title v-else :class="['primary--text', 'lighten-1', 'font-weight-bold']">{{ booking.status }}</v-list-item-title>
					</v-col>
				</v-row>
			</v-list-item-content>

			<v-list-item-avatar v-show="true">
				<v-icon large color="blue lighten-1" @click="viewHistoricalBooking(booking)">mdi-chevron-right</v-icon>
			</v-list-item-avatar>
		</v-list-item>
	</v-card>
</template>

<script>
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';
import axios from 'axios';

export default {
	name: 'BookingHistoryCard',
	components: {},
	props: {
		booking: { type: Object, required: true },
	},
	data: () => ({
		avatar: false,
		no_avatar: store.getters.noAvatar,
		showTimes: true,
		start_time: '',
		end_time: '',
	}),
	mounted() {
		this.getAvatar();
		this.getTimes();
	},
	methods: {
		viewHistoricalBooking(booking_request_set) {
			store.commit('SET_SELECTED_BOOKING', booking_request_set);

			const {
				professional,
				booking_dates,
				booking_dates_times,
				start_time,
				end_time,
				lunch,
				notes,
				id: bookingId,
				profession,
				rates,
				experience,
				skills,
			} = booking_request_set;

			// Set correct booking times
			const request_dates = this.booking.request_dates;
			const booking = { start_time, end_time, lunch, notes, booking_dates, booking_dates_times, id: bookingId, profession, rates, experience, skills, request_dates };

			store.dispatch('setPracticeViewingLocum', [{ id: professional.id, booking, source: 'viewHistoricalBooking' }]);
			bus.$emit('change-context', 'view-locum-details-card');
		},

		dateFormattedMomentjs(date) {
			return date ? moment(date).format('MMM Do YYYY') : '';
		},

		async getAvatar() {
			if (!this.avatar) {
				try {
					let response = await axios.get(store.getters.getDOCUMENTS + '/images/avatar/' + this.booking.professional.id, {
						headers: { Authorization: store.getters.jwtToken },
					});
					this.avatar = 'data:image/png;base64,' + response.data.data;
				} catch (err) {
					this.avatar = 'no_avatar';
				}
			}
		},

		getTimes() {
			this.showTimes = true;
			this.start_time = this.booking.start_time;
			this.end_time = this.booking.end_time;
			for (let index = 0; index < this.booking.request_dates.length; index++) {
				if (
					moment(this.booking.request_dates[index].start_time).format('HH:mm') !== this.booking.start_time ||
					moment(this.booking.request_dates[index].end_time).format('HH:mm') !== this.booking.end_time
				) {
					this.showTimes = false;
					break;
				}
			}
		},
	},
};
</script>
